import { render } from "./geneticHome.vue?vue&type=template&id=d4f3bec0&scoped=true"
import script from "./geneticHome.vue?vue&type=script&lang=js"
export * from "./geneticHome.vue?vue&type=script&lang=js"

import "./geneticHome.vue?vue&type=style&index=0&id=d4f3bec0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f3bec0"]])

export default __exports__